export const T = {
  // Layout / nav
  navBrand: "nav-brand",
  navDashboard: "nav-dashboard",
  navAdmin: "nav-admin",
  navLogout: "nav-logout",
  navLogin: "nav-login",
  navRegister: "nav-register",

  // Landing
  landingCta: "landing-cta",
  landingLogin: "landing-login",

  // Auth
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  loginSubmit: "login-submit",
  registerSubmit: "register-submit",
  authError: "auth-error",
  registerModeInvite: "register-mode-invite",
  registerModeCreate: "register-mode-create",
  inviteCodeInput: "auth-invite-code-input",
  practiceNameInput: "auth-practice-name-input",

  // Dashboard
  dashboardCourseCard: "dashboard-course-card",
  dashboardStartCourse: "dashboard-start-course",
  dashboardCertificateLink: "dashboard-certificate-link",

  // Course
  courseStartLesson: "course-start-lesson",
  courseLessonItem: "course-lesson-item",
  courseFlashcardsBtn: "course-flashcards-btn",
  courseQuizBtn: "course-quiz-btn",

  // Lesson
  lessonComplete: "lesson-complete-btn",
  lessonNext: "lesson-next-btn",
  lessonPrev: "lesson-prev-btn",
  lessonBack: "lesson-back-btn",

  // Quiz
  quizOption: "quiz-option",
  quizNext: "quiz-next-btn",
  quizSubmit: "quiz-submit-btn",
  quizResultScore: "quiz-result-score",
  quizRetry: "quiz-retry-btn",

  // Flashcards
  flashcard: "flashcard",
  flashcardFlip: "flashcard-flip-btn",
  flashcardNext: "flashcard-next-btn",
  flashcardPrev: "flashcard-prev-btn",

  // Certificate
  certificatePrint: "certificate-print-btn",

  // Admin
  adminUsersTable: "admin-users-table",
  adminAttemptsTable: "admin-attempts-table",
  adminPracticeName: "admin-practice-name",
  adminPracticeLogo: "admin-practice-logo",
  adminSignatoryName: "admin-signatory-name",
  adminSignatoryTitle: "admin-signatory-title",
  adminValidityDays: "admin-validity-days",
  adminSaveSettings: "admin-save-settings",
  adminTeamTable: "admin-team-table",
  adminTeamCsv: "admin-team-csv",
  adminTeamSearch: "admin-team-search",
  adminInviteCode: "admin-invite-code",
  adminInviteCopy: "admin-invite-copy",
  adminInviteRegen: "admin-invite-regen",
  adminWipeTestUsers: "admin-wipe-test-users",
};
